import { CompanyAuth } from "../../../entities/login/CompanyAuth";
import CompanyService, {
  DataType,
  Entities
} from "../../../services/CompanyService";

type AdditionalDefinition = CompanyAuth.AdditionalDefinition;
type ConfigItem = CompanyAuth.ConfigItem;

/** Entities.Client field id para ClientFields.Contact (ver src/services/ClientService.ts). */
const CONTACT_FIELD_ID = -22;
const CONTACT_FIELD_DEFAULT_MAX_LENGTH = 100;

export class EntityField {
  id: number = 0;
  title?: string;
  entity: Entities = 0;
  type: DataType = DataType.Text;
  listItems: EntityFieldListItem[] = [];
  Whatsapp: boolean = false;
  ManualEdit: boolean = false;
  maxLength?: number;
  isDefault: () => boolean = () =>
    CompanyService.getEntityFieldIsDefault(this.entity, this.id);

  /** @translate se usa para la mayoría de los campos "default" (ConfigItem), que tienen un título fijo dependiente solo del idioma en uso. */
  constructor(field: AdditionalDefinition | ConfigItem) {
    if (instanceOfAdditionalDefinition(field)) {
      this.LoadAdditionalDefinition(field);
    } else {
      this.LoadConfigItem(field);
    }
    this.maxLength = this.maxLength ?? this.getDefaultMaxLength();
  }

  LoadAdditionalDefinition(field: AdditionalDefinition) {
    this.entity = field.Entity;
    this.id = field.AdditionalDefinitionID;
    this.title = field.Name;
    this.type = field.type || field.Type;
    this.listItems =
      field.AdditionalDefinitionItems?.map(
        (x) =>
          new EntityFieldListItem(
            x.AdditionalDefinitionItemID,
            x.Value,
            x.Default ?? false
          )
      ).sort((a: EntityFieldListItem, b: EntityFieldListItem) =>
        a.value.localeCompare(b.value)
      ) ?? [];
    this.Whatsapp = field.Whatsapp ?? false;
    this.ManualEdit = field.ManualEdit ?? false;
    this.maxLength = field.MaxLength;
  }

  LoadConfigItem = (field: ConfigItem) => {
    this.entity = field.Entity;
    this.id = field.field;
    this.title =
      field.name ?? CompanyService.getEntityFieldTitle(this.entity, this.id);
    this.type = CompanyService.getEntityDefaultFieldType(this.entity, this.id);
    this.ManualEdit = field.ManualEdit ?? false;
    this.Whatsapp = field.Whatsapp || field.whatsapp || false;
    this.maxLength = field.MaxLength;
  };

  private getDefaultMaxLength(): number | undefined {
    if (this.entity === Entities.Client && this.id === CONTACT_FIELD_ID) {
      return CONTACT_FIELD_DEFAULT_MAX_LENGTH;
    }
    return undefined;
  }
}

class EntityFieldListItem {
  constructor(
    public id: number,
    public value: string,
    public Default: boolean
  ) {}
}

const instanceOfAdditionalDefinition =
  (object: {}): object is AdditionalDefinition =>
    "AdditionalDefinitionID" in object;

export const sortEntityFields =
  (idList: (string | number)[]) =>
  (field1: EntityField, field2: EntityField) => {
    const index1 = idList.indexOf(field1.id.toString());
    const index2 = idList.indexOf(field2.id.toString());
    if (index1 === -1) {
      return 1;
    }
    if (index2 === -1) {
      return -1;
    }
    return index1 > index2 ? 1 : -1;
  };
